import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeatureSection from './components/FeatureSection';
import HotArticles from './components/HotArticles';
import TestimonialsFAQ from './components/TestimonialsFAQ';
import CTASection from './components/CTASection';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '俺去也',
  url: 'https://www.anquye.com',
  description: '俺去也是深受用户喜爱的娱乐内容平台，提供海量高清视频资源、极速播放体验与安全稳定的访问通道。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@anquye.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '俺去也',
  url: 'https://www.anquye.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.anquye.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '俺去也需要注册才能观看吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '不需要！俺去也始终坚持免费开放的理念，所有用户无需注册即可免费观看平台上的全部内容。',
      },
    },
    {
      '@type': 'Question',
      name: '视频播放卡顿怎么办？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '可以尝试切换视频清晰度、暂停缓冲、检查网络连接或刷新页面后重新播放。服务器采用全球CDN加速，保证流畅播放。',
      },
    },
    {
      '@type': 'Question',
      name: '内容多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '内容团队每天更新资源，日均更新量超过200部。热门内容通常在24小时内同步更新。',
      },
    },
    {
      '@type': 'Question',
      name: '支持哪些设备观看？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '支持全平台观看，包括PC电脑、平板、手机等各种设备，网站采用响应式设计自动适配。',
      },
    },
    {
      '@type': 'Question',
      name: '如果入口地址无法访问怎么办？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '提供多个备用入口地址，可通过官方社交媒体账号获取最新入口。定期更新入口信息，确保访问稳定性。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeatureSection />
          <HotArticles />
          <TestimonialsFAQ />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}